import React from 'react';
import {appHelpers} from "../../_helpers";
 import { Table, Th, Thead, Tr, Td } from 'reactable';
const InvoiceIssuerTable = ({data}) => {
     return (
        <div>
            <Table className="table table-striped table-hover" id="table" sortable={true} itemsPerPage={15} pageButtonLimit={10} >
                <Thead>
                    <Th column="LegacyCode">
                        <span>Issuer</span>
                    </Th>
                    <Th column="Total" className="text-right">
                        <span>Amount</span>
                    </Th>
                </Thead>
                {data.map((item, i) => <Tr key={i}>
                    <Td column="LegacyCode" className="text-capitalize">{item.LegacyCode}</Td>
                    <Td column="Total" className="text-capitalize text-right">{ appHelpers.numberWithCommas(item.Total)}</Td>
                </Tr>)}
            </Table>
        </div>
    );
};

export default InvoiceIssuerTable;


// WEBPACK FOOTER //
// ./src/views/invoice/invoice-issuer-table.js